import { dispatch, registerHandler } from 'nike-re-framejs';
import { defaultMiddlewares } from '@/common/util';
import { start2FA } from '@/2fa';
import { pageChangeParam } from '@/routing/handlers-ng';
import { REASON_2FA_LOGIN } from 'nike-ui/src/components/2fa/views/reason';
import { updateURLSearchParams } from '@/routing';

registerHandler('login.openScreen', defaultMiddlewares, db => {
    updateURLSearchParams({ prihlasenie: null });
    return db;
});

registerHandler('login.closeScreen', defaultMiddlewares, db => {
    dispatch(['history_back']);
    return db;
});

export function startLogin2FA(e, onSuccess, onClose) {
    console.log('startLogin2FA', e);
    return db => [
        db.deleteIn(['account', 'loginInProgress']),
        pageChangeParam({ prihlasenie: undefined }),
        start2FA(e.jwt, e.methods, REASON_2FA_LOGIN, null, onSuccess, onClose)
    ];
}
